import React, { useState, useEffect } from "react";
import Image from 'react-bootstrap/Image';
import {createElementFromHTML, formatDate, renderRatingStars, stripHTMLFromString} from '../../utils/utilsHelpers';

const quoteSaved = 'bg-soft-primary';
const quoteEdit = 'bg-primary';
const highlighted = 'bg-soft-success';

const MINIMAL_SELECTION_LENGTH = 2;

export default function ReviewQuoteSelection(props) {

    const [tmpSelection, setTmpSelection] = useState('');
    const [isDown, setIsDown] = useState(false);

    const downListener = (e) => {
        setIsDown(true);
    }

    // On mouse move listener, check for text selection
    const moveListener = () => {
        if (isDown && document.getSelection().toString()) {
            const selection = document.getSelection();
            const prohibitedTags = ['h5'];
            if (prohibitedTags.includes(selection.focusNode.parentElement.localName) || prohibitedTags.includes(selection.anchorNode.parentElement.localName)) {
                props.setSelectingText(false);
                selection.empty();
                return;
            }

            props.setSelectingText(true);
            setTmpSelection(selection.toString());
        }
    }

    // On mouse up listener, check if target is a quote and update parent, otherwise clear selected text
    const upListener = (e) => {
        setIsDown(false);

        if (e.target.id) {
            //quote tag clicked
            let quote = props.tagsMapping.find(q => q.id == e.target.id);
            if(quote) {
                props.onQuoteSelect(quote.text);
                return;
            }
        }

        if (!document.getSelection().toString()) {
            setTmpSelection('');
            props.onTextSelect('');
        } else if (tmpSelection && tmpSelection.length > MINIMAL_SELECTION_LENGTH) {
            props.onTextSelect(tmpSelection);
        }
    }

    // Inject selected text as new quote
    const injectNormalQuote = (reviewBodyMapping) => {
        let selectedTextSpan = '';
        if (props.selectedText) {
            selectedTextSpan = `<span class="${highlighted}">${props.selectedText}</span>`;
            for (let [header, body] of Object.entries(reviewBodyMapping)) {
                if (body.includes(props.selectedText)) {
                    reviewBodyMapping[header] = body.replace(props.selectedText, selectedTextSpan);
                    break;
                }
            }
        }
    }

    // Inject vendor quotes
    const injectVendorQuotes = (reviewBodyMapping) => {
        props.tagsMapping.forEach((mapping) => {
            Object.keys(reviewBodyMapping).forEach((key, i) => {
                let header = Object.keys(reviewBodyMapping)[i];
                let sections = reviewBodyMapping[header].split('</p> <p>');
                let quoteArr = mapping.text.split('\n\n');
                sections.forEach(p => {
                    let sectionTxt = stripHTMLFromString(p);
                    quoteArr.filter(q => sectionTxt.includes(q)).forEach(quote => {
                        let bgColor = mapping.isSelected ? quoteEdit : quoteSaved;
                        let textSpan = `<span id="${mapping.id}" class="${bgColor}" style="cursor: pointer">${quote}</span>`;
                        // account for partial quotes and hidden characters
                        if(p === quote) {
                            reviewBodyMapping[header] = reviewBodyMapping[header].replace(quote, textSpan);
                        } else {
                            let txt = sectionTxt.replace(quote, textSpan);
                            reviewBodyMapping[header] = reviewBodyMapping[header].replace(p, '<p>' + txt + '</p>');
                        }
                    });
                });
            })
        })
    }

    // Inject all quotes to review text
    const injectQuotesToText = (reviewBody) => {
        let reviewBodyMapping = {...reviewBody};

        injectNormalQuote(reviewBodyMapping);
        injectVendorQuotes(reviewBodyMapping);

        let formattedReviewBody = '';
        // rebuild review
        Object.keys(reviewBodyMapping).forEach((header) => {
          if (header !== 'non_guided_review_body') formattedReviewBody += `<h5 class="mt-3">${header}</h5>`;
          formattedReviewBody += `<span>${reviewBodyMapping[header]}</span>`;
        })

        return (
            createElementFromHTML(formattedReviewBody)
        )
    }

    // Render author info
    const renderAuthorInfo = () => {
        return (
            <div className="d-flex align-items-center px-3">
                <Image roundedCircle src={props.review.avatar} className="me-2"></Image>
                <div>
                    <span className={'d-flex fw-bold'}>{props.review.name}</span>
                    <span className={'d-flex font-12'}>{props.review.company} {props.review.job_title}</span>
                </div>
                <div className='ms-auto'>
                    <span className={'d-flex justify-content-end font-12'}>{formatDate(props.review.published_date)}</span>
                    <span className={'d-flex justify-content-end'}>{!props.review.reseller && renderRatingStars(props.review.rating)}</span>
                </div>
            </div>
        );
    }

    // Main component renderer
    return (
        <div className={'overflow-auto custom-scroller custom-scroller-transparent col-xl-8 py-3 h-100'} onMouseUp={(e) => upListener(e)}>
            {
                props.review &&
                <div>
                    {renderAuthorInfo()}
                    <h4 className={'page-title mt-3 mb-3 px-3'}>{props.review.title}</h4>
                    <div className={'px-3'} onMouseMove={() => moveListener()} onMouseDown={(e) => downListener(e)}>
                        {injectQuotesToText(props.review.body)}
                    </div>
                </div>
            }
        </div>
    )
}

